module.exports = __webpack_public_path__ + "img/logo-200.636a8a0b.png";